import type { SentBack } from '../../shared/types'
import { Avatar, Pill } from './ui'

const STATUS: Record<SentBack['status'], { label: string; tone: 'warn' | 'accent' | 'ok' }> = {
  not_redone: { label: 'Not redone yet', tone: 'warn' },
  waiting: { label: 'Redone — check it', tone: 'accent' },
  done: { label: 'Approved', tone: 'ok' },
}

/**
 * What a parent sent back today and where each one got to. Sending back unticks
 * the job, so without this it would simply disappear from the parent's view.
 */
export function SentBackCard({ sentBack }: { sentBack: SentBack[] }) {
  if (sentBack.length === 0) return null

  return (
    <section className="card">
      <h2 className="title">Sent back today</h2>
      <div className="list">
        {sentBack.map((item) => {
          const status = STATUS[item.status]
          return (
            <div key={item.id} className="row">
              <Avatar emoji={item.member.emoji} color={item.member.color} size="sm" />
              <span className="grow">
                <span className="check-title">{item.title}</span>
                <span className="check-detail" style={{ display: 'block' }}>
                  {item.member.name} · sent back {timeOf(item.sentBackAt)}
                  {item.sentBackBy ? ` by ${item.sentBackBy}` : ''}
                </span>
              </span>
              <Pill tone={status.tone}>{status.label}</Pill>
            </div>
          )
        })}
      </div>
    </section>
  )
}

function timeOf(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}
